import { useMenu as r } from "../../hooks/useMenu.js";
import { usePopover as i } from "../../../Popover/hooks/usePopover.js";
const u = () => {
  const t = r(), e = i(), o = (t == null ? void 0 : t.role) ?? (e == null ? void 0 : e.type);
  return o === "listbox" ? "option" : o === "menu" ? "menuitem" : o === "list" ? "listitem" : void 0;
};
export {
  u as useMenuItemRole
};
